module.exports = __webpack_public_path__ + "img/20191210161600754.de2b3af2.jpg";